import React from 'react';
import {CSSTransition, Transition, TransitionGroup} from "react-transition-group";
import ramen from '../../images/alps/ramen.png'

import uuid from 'uuid'



function RamenAlp(props) {

    const renderSheep = () => {
        if (true) {
            return  (

                <div>
                    <img src={ramen} style={sheep}/>
                </div>


            )
        }
    }

    return(
        <TransitionGroup>
            <CSSTransition
                key={uuid()}
                timeout={600}
                classNames='fade'>
                {renderSheep}
            </CSSTransition>
        </TransitionGroup>

    )

}


export default RamenAlp



const sheep = {
    position: 'fixed',
    zIndex: -1,
    maxHeight: '90%',
    maxWidth:'100%',
    left:'0',
    right:'0',
    top:'0',
    bottom:'0',
    margin:'auto'
}

